import { ua } from "../wea-tools/userAgent";
import { getFd } from "../wea-tools/callApi";
import {
  desensitization,
  encryption,
  replaceEncryption,
  Encry
} from "../wea-tools/Encry.base";

// 用于合并tabs
export function joinArray(target, origin) {
  const union = [];
  target.forEach(element => {
    const originEle = origin.find(o => o.key == element.key) || {};
    union.push({
      ...originEle,
      ...element,
      dataParams: {
        ...(originEle.dataParams || {}),
        ...(element.dataParams || {})
      },
      browserProps: {
        ...(originEle.browserProps || {}),
        ...(element.browserProps || {})
      }
    });
  });
  return union;
}

// 阻止事件默认行为
export function stopPropagation(e) {
  if (!e) return;
  e.stopPropagation && e.stopPropagation();
  e.preventDefault && e.preventDefault();
  if (e.nativeEvent) {
    e.nativeEvent.stopImmediatePropagation &&
      e.nativeEvent.stopImmediatePropagation();
    e.nativeEvent.preventDefault && e.nativeEvent.preventDefault();
  }
}

// 根据参数的长度来判断是否需要使用POST方式
export function getMethod(url = "", params = {}) {
  const uri = `${url}?${getFd(params)}`;
  const maxLength = ua.browser == "IE" ? 2000 : 6000;
  return uri.length > maxLength ? "POST" : "GET";
}

// 获取浏览按钮已选数据在输入框中是否需要换行显示
export function getValueWarp(browserProps) {
  if (!browserProps) return false;
  const { type, isSingle, dataParams } = browserProps;
  const browserConfig = window.ecBrowserConfig || {};
  const { typeList } = browserConfig;
  const types = typeList || [];
  let valueWarp;
  if (isSingle) {
    valueWarp = false;
  } else if (type === 162 || type === "162") {
    // 自定义多选
    valueWarp = types.indexOf(`${dataParams.type}`) !== -1;
  } else if (type === 257 || type === "257") {
    // 自定义树形多选
    valueWarp = types.indexOf(`tree.${dataParams.treeid}`) !== -1;
  } else {
    // 其他多选浏览按钮
    valueWarp = types.indexOf(`${type}`) !== -1;
  }
  return valueWarp;
}

// 获取浏览按钮每页显示条数
export function getPageSize(browserProps) {
  if (!browserProps) return false;
  const { type, dataParams } = browserProps;
  const browserConfig = window.ecBrowserConfig || {};
  const { pageConfigList, defaultPageSize: dps } = browserConfig;
  const configList = pageConfigList || [];
  const defaultPageSize = dps || 10;
  let pageSize = defaultPageSize;
  configList.map(item => {
    if (item.browserType == type) {
      pageSize = item.pageSize;
    } else if (type == 161 || type == 162) {
      if (item.browserType == dataParams.type) {
        pageSize = item.pageSize;
      }
    }
  });
  return pageSize;
}

export const text = (item, field, pure) => {
  let text = "";
  if (item[field] !== undefined) {
    text = item[field];
  }
  if (item[field + "span"] !== undefined) {
    text = item[field + "span"];
  }
  if (!pure) {
    if (desensitization(text)) {
      return <Encry value={text} />;
    } else if (encryption(text)) {
      text = replaceEncryption(text);
    }
  }
  return text;
};

// 获取【全部添加】一次最多添加条数
export function getSelectAllMaxSize(browserProps) {
  if (!browserProps) return false;
  const { type } = browserProps;
  const browserConfig = window.ecBrowserConfig || {};
  const { selectAllTypeList, defaultSelectAllMaxSize } = browserConfig;
  const typeList = selectAllTypeList || ["17"];
  const maxSize = defaultSelectAllMaxSize || 500;
  return typeList.indexOf(`${type}`) !== -1 ? maxSize : 0;
}

// 过滤文本中的html标签
export function filterHtmlInText(text) {
  if (typeof text === "string") {
    return text.replace(/<[^<>]+>/g, "");
  }
  return text;
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser/util.js